import { Col, Table, TableActionBarRow } from "melco-ui";
import { useTranslation } from "react-i18next";
import { useRolesContext } from "../../hooks/roles/useRolesContext";
import { useManageThreads } from "../../hooks/threads/useManageThreads";
import { PublishedState } from "../state/PublishedState";
import { TableCellLink } from "../table/TableCellLink";
import { FormattedDate } from "../table/FormattedDate";
import { ManageThreadsFilter } from "./ManageThreadsFilter";
import { ControlcenterMelcoModelsThreadChartListItem } from "melco-shared-logic";

type ManageThreadsListPropTypes = {
  isThreadDrawerOpen: boolean;
  setThreadDrawerOpenFunction: (v: boolean) => void;
  threadIdToUpdate: string;
  // threadType: string;
};

const DETAIL_VIEW_PATH = "/system/managethreads";
export const ManageThreadsList: React.FC<ManageThreadsListPropTypes> = () => {
  const {
    isLoading,
    isFetching,
    data,
    isPreviousData,
    errorComponent,
    onTableConfigChange,
    pagination,
    filtersChange,
  } = useManageThreads();

  const { t } = useTranslation();

  const { roles } = useRolesContext();

  const columns = [
    {
      title: t("managethreads.table.columns.id"),
      key: "id",
      sorter: true,
      render: (rowObj: ControlcenterMelcoModelsThreadChartListItem) => {
        return roles.SYSTEM_THREADS_EDIT ? (
          rowObj?.version !== 1 ? <TableCellLink
            onClick={() => {
              // handleEditClick(rowObj?.id ?? "")
            }}
            to={[DETAIL_VIEW_PATH, rowObj.id].join("/")}
          >
            {rowObj.id}
          </TableCellLink> : <TableCellLink to={""} onClick={() => alert(t("managethreads.alert.message"))}>  {rowObj.id}</TableCellLink>
        ) : (
          rowObj.id
        );
      },
    },
    // {
    //   title: t("managethreads.table.columns.code"),
    //   key: "code",
    //   dataIndex: "code",
    //   sorter: true,

    // },
    {
      title: t("managethreads.table.columns.name"),
      key: "file_name",
      dataIndex: "file_name",
      sorter: true,
    },


    {
      title: t("managethreads.table.columns.created_date"),
      key: "created_date",
      sorter: true,

      render: (rowObj: ControlcenterMelcoModelsThreadChartListItem) => (
        <> {<FormattedDate date={rowObj.created_date} />}</>
      ),
    },
    {
      title: t("managethreads.table.columns.published_date"),
      key: "published_date",
      sorter: true,

      render: (rowObj: ControlcenterMelcoModelsThreadChartListItem) => (
        <> {<FormattedDate date={rowObj.publish_date} />}</>
      ),
    },
    {
      title: t("managethreads.table.columns.publish_state"),
      key: "publish_state",
      sorter: true,
      render: (rowobj: ControlcenterMelcoModelsThreadChartListItem) => {
        return <PublishedState publishedState={rowobj.publish_state ?? 1} />;
      },
    },
  ];

  return (
    <>
      <TableActionBarRow>
        <Col xs={24} md={24} xl={24}>
          <ManageThreadsFilter onFiltersChange={filtersChange} />
        </Col>
      </TableActionBarRow>

      <Table
        showSorterTooltip={false}
        sticky
        loading={isPreviousData ? isFetching : isLoading}
        dataSource={data}
        columns={columns}
        onChange={onTableConfigChange}
        pagination={pagination}
        rowKey="id"
        noDataMessage={t("managethreads.table.no_threads_message")}
        errorComponent={errorComponent}
      />
    </>
  );
};
